import _ from "lodash";
import { SocialSettings } from "../../../../cores/me/interfaces/api/get-meSocialSettings";
import { SummaryPlatform, SyncedPlatforms } from "./summaryAnalyticsTypes";

export interface SummaryPlatformSources {
  socialSettings: SocialSettings | null;
  facebookSettings?: object | null;
  instagramSettings?: object | null;
  tiktokSettings?: object | null;
}

export const getSummarySyncedPlatforms = (
  sources: SummaryPlatformSources
): SyncedPlatforms => ({
  facebook:
    Boolean(sources.socialSettings?.facebook) ||
    !_.isEmpty(sources.facebookSettings),
  instagram:
    Boolean(sources.socialSettings?.instagram) ||
    !_.isEmpty(sources.instagramSettings),
  tiktok: !_.isEmpty(sources.tiktokSettings),
});

export const getSummarySyncedPlatformList = (
  sources: SummaryPlatformSources
): SummaryPlatform[] => {
  const platforms = getSummarySyncedPlatforms(sources);
  const list: SummaryPlatform[] = [];
  if (platforms.facebook) list.push("facebook");
  if (platforms.instagram) list.push("instagram");
  if (platforms.tiktok) list.push("tiktok");
  return list;
};

export const hasAnySummaryPlatform = (sources: SummaryPlatformSources) =>
  getSummarySyncedPlatformList(sources).length > 0;
